import {toJsonValues} from "../../../form/translate/to_json_values";
import {addSuccessNotification} from "../../../notifications/utils/add_success_notification";
import {addAppliedOffers} from "../../../offer/map/actions/add_applied_offers";
import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IAppDispatch} from "../../../store/store";
import {Currency} from "../../../types/Currency";
import {ViewType} from "../../../view_type/ViewType";
import {RecommendedOfferApplicationsType} from "../../actions/multi_lead/track_recommended_offers_application";
import {createMultipleApplications} from "../../api/create_multiple_applications";
import {applicationFormFields} from "../../constants/form/application_form_fields";
import {IApplicationAdditionalQuestionTypes} from "../../types/form/IApplicationFormAdditionalQuestionTypes";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {IPostMultipleApplicationsPayload} from "../../types/lead/IPostMultipleApplicaitonsPayload";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {alertFormSuccessMessage} from "../form/application_form_alert_text";
import {ApplicationSource, ApplicationSourceSection} from "../form/application_form_source";
import {getGeneratedMessage} from "../form/get_generated_message";
import {report} from "./application_multi_lead_analytics_events";
import {addOffersToStorageSentApplication} from "./get_storage_sent_applications_id_list_by";

// Data used in reporting purposes both by backend and platforms like algolytics tracker and GTM
interface IPropertyMultiApplicationMetadata {
    refererApplicationUUID: string | undefined;
    viewType: ViewType | null;
    sourceSection: ApplicationSourceSection;
    isAuthenticated: boolean;
    application: IApplicationData | undefined | null;
    originalFormParams: {
        rooms: number[];
        questions?: IApplicationAdditionalQuestionTypes[];
    };
    currency?: Currency;
}

interface IPropertyMultiApplicationPayload {
    selectedRecommendations: IRecommendedOffer[];
    formValues: IApplicationFormValues;
    currency?: Currency;
}

export const applicationMultiLeadSendOffer =
    (payload: IPropertyMultiApplicationPayload, metadata: IPropertyMultiApplicationMetadata) => (dispatch: IAppDispatch) => {
        // TODO: this shouldn't be JsonValues type, refactor when migrating to rhf
        const jsonValues = toJsonValues(applicationFormFields, payload.formValues) as Pick<
            IApplicationFormValues,
            "name" | "marketing_email" | "marketing_sms"
        >;
        const source = ApplicationSource.RecommendedOffer;

        if ("text" in jsonValues) {
            delete jsonValues.text;
        }

        const createPayload: IPostMultipleApplicationsPayload = {
            ...jsonValues,
            home_match_trigger: true,
            referer_application_uuid: metadata.refererApplicationUUID,
            source,
            source_section: metadata.sourceSection,
            applications: payload.selectedRecommendations.map((recommendedOffer) => ({
                text: getGeneratedMessage({
                    offerType: recommendedOffer.type,
                    offerName: recommendedOffer.name,
                    name: payload.formValues.name
                }),
                offer: recommendedOffer.id
            }))
        };

        return dispatch(createMultipleApplications.initiate(createPayload))
            .unwrap()
            .then((response) => {
                dispatch(addSuccessNotification(alertFormSuccessMessage));

                const applications = response.applications;

                if (!applications.filter(Boolean).length) {
                    return [];
                }

                const offerIDs = applications.reduce<number[]>((acc, application) => {
                    return application ? acc.concat(application.offer) : acc;
                }, []);

                if (metadata.isAuthenticated) {
                    dispatch(addAppliedOffers(offerIDs));
                }

                addOffersToStorageSentApplication(
                    payload.selectedRecommendations.map((offer) => {
                        return {id: offer.id, coordinates: offer.geo_point.coordinates, country: offer.region.country, regionId: offer.region.parent?.id};
                    })
                );

                const createdApplications = applications.reduce<RecommendedOfferApplicationsType[]>((acc, application) => {
                    if (application) {
                        const recommendedOffer = payload.selectedRecommendations.find(({id}) => id === application.offer);

                        report.singleApplicationSuccess(application, metadata.sourceSection, metadata.viewType);

                        if (recommendedOffer) {
                            acc.push([application, recommendedOffer]);
                        }
                    }
                    return acc;
                }, []);

                report.finishedSending(
                    ApplicationMultiLeadRecommendationType.OFFER,
                    createdApplications,
                    metadata.viewType,
                    "standard",
                    metadata.application,
                    false,
                    undefined,
                    metadata.currency
                );

                return createdApplications;
            });
    };
import {toJsonValues} from "../../../form/translate/to_json_values";
import {addSuccessNotification} from "../../../notifications/utils/add_success_notification";
import {addAppliedOffers} from "../../../offer/map/actions/add_applied_offers";
import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IAppDispatch} from "../../../store/store";
import {Currency} from "../../../types/Currency";
import {ViewType} from "../../../view_type/ViewType";
import {RecommendedOfferApplicationsType} from "../../actions/multi_lead/track_recommended_offers_application";
import {createMultipleApplications} from "../../api/create_multiple_applications";
import {applicationFormFields} from "../../constants/form/application_form_fields";
import {IApplicationAdditionalQuestionTypes} from "../../types/form/IApplicationFormAdditionalQuestionTypes";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {IPostMultipleApplicationsPayload} from "../../types/lead/IPostMultipleApplicaitonsPayload";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {alertFormSuccessMessage} from "../form/application_form_alert_text";
import {ApplicationSource, ApplicationSourceSection} from "../form/application_form_source";
import {getGeneratedMessage} from "../form/get_generated_message";
import {report} from "./application_multi_lead_analytics_events";
import {addOffersToStorageSentApplication} from "./get_storage_sent_applications_id_list_by";

// Data used in reporting purposes both by backend and platforms like algolytics tracker and GTM
interface IPropertyMultiApplicationMetadata {
    refererApplicationUUID: string | undefined;
    viewType: ViewType | null;
    sourceSection: ApplicationSourceSection;
    isAuthenticated: boolean;
    application: IApplicationData | undefined | null;
    originalFormParams: {
        rooms: number[];
        questions?: IApplicationAdditionalQuestionTypes[];
    };
    currency?: Currency;
}

interface IPropertyMultiApplicationPayload {
    selectedRecommendations: IRecommendedOffer[];
    formValues: IApplicationFormValues;
    currency?: Currency;
}

export const applicationMultiLeadSendOffer =
    (payload: IPropertyMultiApplicationPayload, metadata: IPropertyMultiApplicationMetadata) => (dispatch: IAppDispatch) => {
        // TODO: this shouldn't be JsonValues type, refactor when migrating to rhf
        const jsonValues = toJsonValues(applicationFormFields, payload.formValues) as Pick<
            IApplicationFormValues,
            "name" | "marketing_email" | "marketing_sms"
        >;
        const source = ApplicationSource.RecommendedOffer;

        if ("text" in jsonValues) {
            delete jsonValues.text;
        }

        const createPayload: IPostMultipleApplicationsPayload = {
            ...jsonValues,
            home_match_trigger: true,
            referer_application_uuid: metadata.refererApplicationUUID,
            source,
            source_section: metadata.sourceSection,
            applications: payload.selectedRecommendations.map((recommendedOffer) => ({
                text: getGeneratedMessage({
                    offerType: recommendedOffer.type,
                    offerName: recommendedOffer.name,
                    name: payload.formValues.name
                }),
                offer: recommendedOffer.id
            }))
        };

        return dispatch(createMultipleApplications.initiate(createPayload))
            .unwrap()
            .then((response) => {
                dispatch(addSuccessNotification(alertFormSuccessMessage));

                const applications = response.applications;

                if (!applications.filter(Boolean).length) {
                    return [];
                }

                const offerIDs = applications.reduce<number[]>((acc, application) => {
                    return application ? acc.concat(application.offer) : acc;
                }, []);

                if (metadata.isAuthenticated) {
                    dispatch(addAppliedOffers(offerIDs));
                }

                addOffersToStorageSentApplication(
                    payload.selectedRecommendations.map((offer) => {
                        return {id: offer.id, coordinates: offer.geo_point.coordinates, country: offer.region.country, regionId: offer.region.parent?.id};
                    })
                );

                const createdApplications = applications.reduce<RecommendedOfferApplicationsType[]>((acc, application) => {
                    if (application) {
                        const recommendedOffer = payload.selectedRecommendations.find(({id}) => id === application.offer);

                        report.singleApplicationSuccess(application, metadata.sourceSection, metadata.viewType);

                        if (recommendedOffer) {
                            acc.push([application, recommendedOffer]);
                        }
                    }
                    return acc;
                }, []);

                report.finishedSending(
                    ApplicationMultiLeadRecommendationType.OFFER,
                    createdApplications,
                    metadata.viewType,
                    "standard",
                    metadata.application,
                    false,
                    undefined,
                    metadata.currency
                );

                return createdApplications;
            });
    };
